import React, { useEffect, useRef, memo } from "react";

import "./SideMenuWrap.style.scss";

import { SideMenuSelection, SideMenuStraps } from "..";

import { useSideMenu } from "../../sideMenu.context";

const Component = memo(({ select }) => {
  const List = {
    straps: <SideMenuStraps />,
    selection: <SideMenuSelection />,
    default: <></>,
  };
  return List[select] || List.default;
});

const SideMenuWrap = () => {
  const { open, setOpen } = useSideMenu();

  const el = useRef();

  useEffect(() => {
    if (open) {
      el.current.style.display = "block";
    } else if (open === false) {
      el.current.classList.add("StrapSideMenuWrap-Close");
      setTimeout(() => {
        el.current.style.display = "none";
        el.current.classList.remove("StrapSideMenuWrap-Close");
      }, 400);
    }
  }, [open]);

  return (
    <div ref={el} className="StrapSideMenuWrap">
      <div className="StrapSideMenuWrap-Side">
        <div className="StrapSideMenuWrap-Side-Header">
          <div
            onClick={() => setOpen(false)}
            className="StrapSideMenuWrap-Side-Header-Close"
          >
            <div />
          </div>
        </div>
        <div className="StrapSideMenuWrap-Side-Content">
          <Component select={open} />
        </div>
      </div>
    </div>
  );
};

export default memo(SideMenuWrap);
